<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: SiteStatsRelations                                    |
| Section: views/overviews                                         |
| Purpose: Site-stats tab focused on kinship relation metrics.     |
+------------------------------------------------------------------+
-->
<template>
    <div class="wrapper overview-wrapper overview-gap-48 relations-fullscreen-page">
        <div class="overview-header stats-header">
            <h1 class="overview-header-text">{{ $t('siteStatsRelations.title') }}</h1>
            <p class="subtitle overview-header-text">{{ $t('siteStatsRelations.subtitle') }}</p>
        </div>

        <BloodRelativesDiagram :cooperativeGestures="cooperativeGestures" />
    </div>
</template>

<script>
import { applyGenericSeo, applyBreadcrumbSeo } from '@/utils/seoUtils';
import BloodRelativesDiagram from '@/components/BloodRelativesDiagram.vue';

export default {
    name: 'SiteStatsRelations',
    components: {
        BloodRelativesDiagram,
    },
    props: {
        cooperativeGestures: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        const locale = this.$route?.params?.locale;
        const localizedPath = (path) => (locale ? `/${locale}${path}` : path);

        applyGenericSeo({
            title: this.$t('siteStatsRelations.seoTitle'),
            description: this.$t('siteStatsRelations.seoDescription'),
            path: localizedPath('/statistieken/relaties'),
        });

        applyBreadcrumbSeo([
            { name: this.$t('nav.home'), path: localizedPath('/') },
            { name: this.$t('siteStatsOverview.title'), path: localizedPath('/statistieken') },
            { name: this.$t('siteStatsRelations.title'), path: localizedPath('/statistieken/relaties') },
        ]);
    },
};
</script>

<style scoped>
.relations-fullscreen-page {
    width: 100vw;
    max-width: none;
    min-height: 100vh;
    min-height: 100dvh;
    height: 100vh;
    height: 100dvh;
    margin: 0;
    padding: 0;
    gap: 0;
    background-color: transparent;
    background-image: none;
}

.relations-fullscreen-page .overview-header {
    display: none;
}

.relations-fullscreen-page :deep(.blood-relatives-wrap) {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    border-radius: 0;
}

.relations-fullscreen-page :deep(.diagram-viewport) {
    flex: 1;
    height: 0;
    border-radius: 0;
}
</style>
